import React from 'react';

import styles from './How.m.sass';
import Feature from '../feature/Feature';

import choseIcon from '../feature/assets/chose.svg';
import orderIcon from '../feature/assets/order.svg';
import executeIcon from '../feature/assets/execute.svg';
import doneIcon from '../feature/assets/done.svg';

export default function How() {
  return (
    <section className={styles.how}>
      <div className={styles.howWrapper}>
        <div className="container">
          <h2 className={styles.header}><span className={styles.headerAccent}>How</span> It Works?</h2>

          <div className={styles.items}>
            <Feature
              icon={choseIcon}
              header="Choose a service"
              desc="If you have questions, our support will help you 24/7."
            />
            <Feature
              icon={orderIcon}
              header="Place an order"
              desc="Enter your contact information and your character data, pay for the order"
            />
            <Feature
              icon={executeIcon}
              header="We execute your order"
              desc="Our support will contact you to clarify the details, and we will immediately proceed to the execution of the order"
            />
            <Feature
              icon={doneIcon}
              header="All done"
              desc="Do not forget to leave a review and tell friends about us"
            />
          </div>
        </div>
      </div>
    </section>
  );
}




// WEBPACK FOOTER //
// ./components/how/How.js